import { PrimaryAddress } from './primary-address';

export class PrimaryCompanyAddress {
    public companyAddressKey: string;
    public refCompanyKey: string;
    public isPrimary: boolean;
    public officeName: string;
    public phoneNumber: string;
    public emailAddress: string;
    public address: PrimaryAddress;
    public externalId: string;
    public rawAddress: PrimaryAddress;
    public companyName: string;
    public companyLegalName: string;
    constructor(obj?: {
       companyAddressKey?: string;
       refCompanyKey?: string;
       isPrimary?: boolean;
       officeName?: string;
       phoneNumber?: string;
       emailAddress?: string;
       address?: PrimaryAddress;
       externalId?: string;
       rawAddress?: PrimaryAddress;
       companyName?: string;
       companyLegalName?: string;
    }) {
        if (obj != null) {
            this.companyAddressKey = typeof obj.companyAddressKey === 'undefined' ? this.companyAddressKey : obj.companyAddressKey;
            this.refCompanyKey = typeof obj.refCompanyKey === 'undefined' ? this.refCompanyKey : obj.refCompanyKey;
            this.isPrimary = typeof obj.isPrimary === 'undefined' ? this.isPrimary : obj.isPrimary;
            this.officeName = typeof obj.officeName === 'undefined' ? this.officeName : obj.officeName;
            this.phoneNumber = typeof obj.phoneNumber === 'undefined' ? this.phoneNumber : obj.phoneNumber;
            this.emailAddress = typeof obj.emailAddress === 'undefined' ? this.emailAddress : obj.emailAddress;
            this.address = typeof obj.address === 'undefined' ? this.address : obj.address;
            this.externalId = typeof obj.externalId === 'undefined' ? this.externalId : obj.externalId;
            this.rawAddress = typeof obj.rawAddress === 'undefined' ? this.rawAddress : obj.rawAddress;
            this.companyName = typeof obj.companyName === 'undefined' ? this.companyName : obj.companyName;
            this.companyLegalName = typeof obj.companyLegalName === 'undefined' ? this.companyLegalName : obj.companyLegalName;
        }
    }
}
